import { createApp } from 'vue';
import { registerSW } from 'virtual:pwa-register';
import App from './ui/App.vue';
import { i18n } from './ui/i18n';
import { initTheme } from './ui/composables/useTheme';
import './ui/styles.css';

initTheme();
registerSW({ immediate: true });
createApp(App).use(i18n).mount('#app');
